import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, LogIn } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import logo from "@/assets/sortiven-logo.png";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email.trim().toLowerCase(), password);
      toast.success(`Bienvenido, ${u.nombre}`);
      navigate("/consola");
    } catch {
      toast.error("Credenciales inválidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-theme="institutional" className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="mb-6 flex items-center justify-center">
          <img src={logo} alt="SORTIVEN — Sorteador Integral" className="h-14 w-auto" />
        </Link>
        <Card>
          <CardHeader><CardTitle className="font-display text-xl">Acceso a la consola</CardTitle></CardHeader>
          <CardContent>
            <form onSubmit={onSubmit} className="space-y-4">
              <div>
                <Label htmlFor="email">Correo</Label>
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="usuario@sorteador.ve" required data-testid="login-email-input" />
              </div>
              <div>
                <Label htmlFor="password">Contraseña</Label>
                <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password-input" />
              </div>
              <Button type="submit" className="w-full gap-2" disabled={loading} data-testid="login-submit-button">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <LogIn className="h-4 w-4" />} Ingresar
              </Button>
            </form>
            <Link to="/" className="mt-4 block text-center text-xs text-primary hover:underline">← Volver al sitio público</Link>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
